<script lang="ts">
    import { State } from "../state.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";
    import ColoredModal from "../colored/ColoredModal.svelte";

    let {isOpen = $bindable()}: {
        isOpen: boolean,
    } = $props();

    const themeClasses = `
        frappe:text-ctp-pink
        frappe:bg-ctp-base
    `;

    function prompt() {
        if (!("Notification" in window)) return;
        Notification.requestPermission().then((permission) => {
            State.options.notificationPermission = permission === "granted";
        }).catch(() => {
            console.log("Notification permission not supported");
            State.options.notificationPermission = false;
        });
    }

    function decline() {
        State.options.notificationPermission = false;
    }

</script>

<ColoredModal autoclose bind:open={isOpen} title="Notifications">
    <p class="text-base leading-relaxed">Do you want to
        enable notifications?</p>
    <p class="text-base leading-relaxed">Notifications are
        used to alert you when it's
        time to do your DAR.</p>

    {#snippet footer()}
        <ColoredButton onclick={prompt}>Yes, enable
        </ColoredButton>
        <ColoredButton color="red" onclick={decline}>No, do not enable</ColoredButton>
    {/snippet}
</ColoredModal>